/* eslint-disable import/prefer-default-export */
import { IProductActionTrackingContext } from '../../shared/types';

export function getEventLabelByContext({
    eventCategory = 'none',
    eventAction = 'findInStore',
    eventLabel,
    type
}: IProductActionTrackingContext) {
    let contextEventLabel;

    switch (type) {
        case 'Page':
            contextEventLabel = 'pdp';
            break;
        default:
            contextEventLabel = eventLabel;
    }

    return { eventAction, eventCategory, eventLabel: contextEventLabel };
}
